import type { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import EyeOff from '../../../../../../assets/icons/eye-off.svg?react';
import EyeOn from '../../../../../../assets/icons/eye-on.svg?react';
import type { Session } from '../../../../../../core/domain/Session';
import { ToggleSessionOnMapCommand } from '../../../../../../core/networkMap/commands/ToggleSessionOnMapCommand';
import { isSessionShownQuery } from '../../../../../../core/networkMap/queries';
import { useAppDispatch, useAppSelector } from '../../../../../../types';
import IconButton from '../../../../../../design/IconButton';

export type Props = {
    session: Session;
};
const ToggleSessionOption: FC<Props> = ({ session }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const sessionIsShownInStore = useAppSelector(isSessionShownQuery(session.id));

    const handleToggleSession = (e: MouseEvent) => {
        e.stopPropagation();
        dispatch(
            ToggleSessionOnMapCommand({
                sessionId: session.id,
                shown: !sessionIsShownInStore,
            }),
        );
    };

    return sessionIsShownInStore ? (
        <IconButton label={t('networkMap.sessionsPanel.toggleSessionOn')} onClick={handleToggleSession}>
            <EyeOn />
        </IconButton>
    ) : (
        <IconButton label={t('networkMap.sessionsPanel.toggleSessionOff')} onClick={handleToggleSession}>
            <EyeOff />
        </IconButton>
    );
};

export default ToggleSessionOption;
